import Web3 from 'web3'
export let smartContract = {
  data() {
    return {
      status: false,
      form: {
        address: "",
        quantity: ""
      },
      account: "Numero de cuenta metamasks"
    };
  },
  methods: {
    async connect() {
      if (window.ethereum) {
        try {

          await window.ethereum.request({ method: 'eth_requestAccounts' })
          this.$toast.success(this.$t('connect-metamask'), {
            position: "top-right"
          })
          this.status = true
          // mainnet 
          // web3 = new Web3('https://bsc-dataseed1.binance.org:443');

          // testnet
          const web3 = new Web3('https://data-seed-prebsc-1-s1.binance.org:8545');

          console.log(web3)

        } catch (error) {
          console.log(error)
          this.status = false
          this.$toast.error(this.$t('reject-conection'), {
            position: "top-right"
          })
        }
      } else {
        this.$toast.error(this.$t('need-provider-web3'), {
          position: "top-right"
        })
      }
    }
  }
}